import { displayToastError, http } from 'app';
import { IThumbsFeedback } from 'app/utils';

export const sendThumbsFeedback = async (
  businessArea: string,
  service: string,
  body: IThumbsFeedback
): Promise<any> => {
  try {
    const response = await http.post(
      '/:businessArea/:service/feedback'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      body
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Send Thumbs Feedback');
  }
};
